import BookmakerImportsListField from "./BookmakerImportsListField";
import ChannelsListField from "./ChannelsListField";
import DealsListField from "./DealsListField";
import LandingsListField from "./LandingsListField";

const getCommonListProps = (props) => ({
	exporter: false,
	hasCreate: true,
	hasEdit: false,
	hasList: true,
	hasShow: false,
	filterDefaultValues: {
		bookmaker_id: props.record.id,
	},
	filterValues: {
		bookmaker_id: props.record.id,
	},
	sort: { field: "id", order: "DESC" },
	match: props.match,
	location: props.location,
	path: props.path,
	title: " ",
	component: "div",
});

export {
	BookmakerImportsListField,
	ChannelsListField,
	DealsListField,
	getCommonListProps,
	LandingsListField,
};
